module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18554/js/img/valuePropModals/WhatsApp/ValueProp1.svg"